import { ClassName, cx } from '@/utils/cx'
import './FlagEmoji.css'

interface FlagEmojiProps {
  /** Flag emoji string, e.g. '🇩🇰' (see getFlagEmoji). Renders nothing when empty. */
  emoji: string
  /** Accessible name. Omit when an adjacent text label already names the country. */
  label?: string
  className?: ClassName
}

/** Renders a country flag emoji in the polyfilled Twemoji flag font. Size via --flag-emoji-size. */
export const FlagEmoji = ({ emoji, label, className }: FlagEmojiProps) => {
  if (!emoji) return null

  return (
    <span
      className={cx('flag-emoji', className)}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      {emoji}
    </span>
  )
}
